<div class="mm-dialog" *ngIf="attribute && attributeOptions"
     [mmTestId]="'PRODUCT_CATALOG.FILTER_MODAL'">
  <form [formGroup]="attributeOptionsModalForm" (ngSubmit)="onFiltersApplied()">
    <div class="mm-dialog__header">
      <h4>{{ attribute?.name }}:</h4>
      <div class="mm-dialog__close"
           [mmTestTarget]="'attribute-modal-close-button'"
           (click)="onClose()">
        <mm-icon name="close" class="modal-close-icon"></mm-icon>
      </div>
    </div>
    <div class="mm-dialog__content">
      <ng-container *ngTemplateOutlet="isMobileOrTablet ? mobileContent : desktopContent"></ng-container>
    </div>

    <ng-template #mobileContent>
      <div class="attribute-list__modal mobile"  fxLayout="row wrap" fxLayoutGap="40px">
        <div fxFlex.mm-mobile="0 0 calc(100% - 40px)" fxFlex.mm-tablet="0 0 calc(100% - 40px)" *ngFor="let option of attributeOptions">
          <ng-container *ngTemplateOutlet="attributeOptionContent; context: { option: option }"></ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #desktopContent>
      <div class="attribute-list__modal" fxLayout="row" fxLayoutAlign="space-between start">
        <ng-container *ngFor="let index of indices">
          <div fxLayout="column wrap" fxFlex="0 0 calc(33% - 40px)">
            <ng-container *ngFor="let option of attributeOptions.slice(index, index + optionsPerColumn);">
              <ng-container *ngTemplateOutlet="attributeOptionContent; context: { option: option }"></ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #attributeOptionContent let-option="option">
      <div fxLayout="row nowrap" fxLayoutAlign="space-between center">
        <mm-checkbox [formControlName]="attribute?.id + '--' + option?.value"
                     [mmTestTarget]="'attribute-modal-filter'"
                     labelType="short"
                     (change)="onOptionSelected(option, $event)">
          {{option?.name}}
        </mm-checkbox>
        <div class="attribute-list-item__count">{{option?.totalCount}}</div>
      </div>
    </ng-template>

    <div class="mm-dialog__footer" fxLayout="row" fxLayoutAlign="end center">
      <button type="submit" mm-button
              [mmTestTarget]="'attribute-modal-apply-button'">
        {{'FILTERS.MODAL.APPLY' | translate}}
      </button>
    </div>
  </form>
</div>
